/**
 * SL Collection Filters — native Shopify facets only.
 * Product filtering is server-side via collection.filters + facets.js.
 */
(function () {
  'use strict';

  var drawerEl = document.getElementById('SlCollectionDrawer');
  var overlayEl = document.getElementById('SlCollectionDrawerOverlay');
  var openButtons = document.querySelectorAll('[data-sl-filter-open]');

  function setDrawerState(open) {
    if (!drawerEl) return;
    drawerEl.classList.toggle('is-open', open);
    if (overlayEl) overlayEl.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    drawerEl.setAttribute('aria-hidden', open ? 'false' : 'true');
    openButtons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  openButtons.forEach(function (btn) {
    btn.addEventListener('click', function () { setDrawerState(true); });
  });
  document.querySelectorAll('[data-sl-filter-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { setDrawerState(false); });
  });
  if (overlayEl) overlayEl.addEventListener('click', function () { setDrawerState(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawerState(false);
  });

  function submitNativeForm(form) {
    if (!form) return;
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }

  var toolbarSort = document.querySelector('.sl-collection__sort-select');
  if (toolbarSort) {
    toolbarSort.addEventListener('change', function () {
      var mainForm = document.getElementById('FacetFiltersForm');
      if (mainForm) {
        var hidden = mainForm.querySelector('input[name="sort_by"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'sort_by';
          mainForm.appendChild(hidden);
        }
        hidden.value = this.value;
        submitNativeForm(mainForm);
      } else {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', this.value);
        params.delete('page');
        window.location.href = window.location.pathname + '?' + params.toString();
      }
    });
  }

  var mobileSort = document.querySelector('.sl-collection__drawer-sort-select');
  if (mobileSort) {
    mobileSort.addEventListener('change', function () {
      var mobileForm = document.getElementById('FacetFiltersFormMobile');
      if (mobileForm) submitNativeForm(mobileForm);
    });
  }

  var applyBtn = document.querySelector('.sl-collection__drawer-apply');
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var mobileForm = document.getElementById('FacetFiltersFormMobile');
      if (mobileForm) submitNativeForm(mobileForm);
      window.setTimeout(function () { setDrawerState(false); }, 350);
    });
  }

  function updateFilterBadge() {
    var params = new URLSearchParams(window.location.search);
    var count = 0;
    params.forEach(function (_value, key) {
      if (key.indexOf('filter.') === 0) count += 1;
    });
    document.querySelectorAll('.sl-collection__mobile-filter-count').forEach(function (badge) {
      badge.textContent = count > 0 ? String(count) : '';
      badge.dataset.count = String(count);
    });
  }

  function applyShowMore(maxVisible) {
    maxVisible = maxVisible || 7;
    document.querySelectorAll('.sl-collection__sidebar-facets .thb-filter ul').forEach(function (ul) {
      if (ul.dataset.showMoreApplied) return;
      ul.dataset.showMoreApplied = '1';
      var items = Array.from(ul.querySelectorAll('li'));
      if (items.length <= maxVisible) return;
      items.forEach(function (li, index) {
        if (index >= maxVisible) li.style.display = 'none';
      });
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sl-show-more-btn';
      btn.textContent = 'Meer tonen (' + (items.length - maxVisible) + ')';
      btn.addEventListener('click', function () {
        items.forEach(function (li) { li.style.display = ''; });
        btn.remove();
      });
      ul.after(btn);
    });
  }

  updateFilterBadge();
  applyShowMore(7);
  window.addEventListener('popstate', updateFilterBadge);

  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && window.MutationObserver) {
    new MutationObserver(function () {
      updateFilterBadge();
      applyShowMore(7);
    }).observe(gridContainer, { childList: true, subtree: false });
  }
})();